import { EventEmitter } from 'eventemitter3'
import { CoinStore } from './CoinStore'

var MIN_DATA_POINTS = 3
var MAX_DATA_POINTS = 6
var ALERT_FREQEUNCY = 600000

var TriggerTypes = [
  ['cross', 'Crossing'],
  ['cross-up', 'Crossing Up'],
  ['cross-down', 'Crossing Down'],
  ['move-up-prct', 'Moving Up %'],
  ['move-down-prct', 'Moving Down %'],
]

class Alert {
	// each alert has a unique id because we can have multiple alerts for a coin
	constructor(symbol, target, trigger) {
    if (typeof symbol === 'object') {
      Object.assign(this, symbol)
      this.lastTriggerDate = new Date(this.lastTriggerDate)
    } else {
      this.id = new Date().getTime()
      this.target = target
      this.symbol = symbol
      this.trigger = trigger || 'cross'
      this.lastTriggerDate = null
    }

    this.prices = []

    // define how long to keep price series if trigger is % change
    // eg, we want to detect 5% change over 30 seconds
    // just make this fixed for now
    if (this.trigger.indexOf('prct') !== -1) {
      this.history = 30000
    }
	}

  reset() {
    this.lastTriggerDate = null
  }

  getReducer(type) {
    var threshold = Number(this.target)

    // cross means previous prices are *all* below or above target
    // but last price is now on the *other* side
    // NOTE: we do not require price to stay on *that* side after crossing
    if (type === 'cross') {
      return (acc, data) => {
        // in acc, we store the direction (below/above),
        // the last known price in acc (um... not actually used)
        // whether cross has been detected (once detected, remain true)
        var last = Number(data.close)
        var direction = last > threshold ? 'above' : 'below'
        var triggered = false

        if (acc === false) {
          // first iteration, nothing to do
          acc = {last, direction, triggered}
        } else if (acc.triggered === false) {
          triggered = (acc.direction !== direction)
          acc = {last, direction, triggered}
        }
        
        return acc
      }
    }
    else if (type === 'cross-up') {
      return (acc, data) => {
        var last = Number(data.close)
        var direction = last > threshold ? 'above' : 'below'
        var triggered = false

        if (acc === false) {
          // first iteration, nothing to do
          acc = {last, direction, triggered}
        } else if (acc.triggered === false) {
          if (acc.direction === 'below' && direction === 'above') {
            triggered = true
          }
          acc = {last, direction, triggered}
        }

        return acc
      }
    }
    else if (type === 'cross-down') {
      return (acc, data) => {
        var last = Number(data.close)
        var direction = last > threshold ? 'above' : 'below'
        var triggered = false

        if (acc === false) {
          // first iteration, nothing to do
          acc = {last, direction, triggered}
        } else if (acc.triggered === false) {
          if (acc.direction === 'above' && direction === 'below') {
            triggered = true
          }
          acc = {last, direction, triggered}
        }

        return acc
      }
    }
    else if (type === 'move-up-prct') {
      return (acc, data) => {
        var last = Number(data.close)

        if (acc === false) {
          // first iteration, set min and max, first price
          acc = { min: last, max: last, triggered: false, first: last }
        } else {
          if (last > acc.max) {
            acc.max = last
          }
          if (last < acc.min) {
            acc.min = last
          }
          // we are dealing with percentages so multiply by 100
          var prctDiff = Math.round((acc.max - acc.min) / acc.min * 100)
          // percentage change is always positive
          if (prctDiff >= threshold) {
            // also check we are moving in the right direction
            acc.triggered = (last > acc.first)
          }
        }

        return acc
      }
    }
    else if (type === 'move-down-prct') {
      return (acc, data) => {
        var last = Number(data.close)

        if (acc === false) {
          // first iteration, set min and max
          acc = { min: last, max: last, triggered: false }
        } else {
          if (last > acc.max) {
            acc.max = last
          }
          if (last < acc.min) {
            acc.min = last
          }
          // we are dealing with percentages so multiply by 100
          var prctDiff = Math.round((acc.max - acc.min) / acc.min * 100)
          // percentage change is always positive
          if (prctDiff >= threshold) {
            // also check we are moving in the right direction
            acc.triggered = (last < acc.first)
          }
        }

        return acc
      }
    }
  }

  throttle(now) {
    // return false to disable alert
    return (now.getTime() - this.lastTriggerDate.getTime() > ALERT_FREQEUNCY)
  }

  check(data) {
    let {close, date} = data

    // DEBUG ONLY --- fake data to check crossing trigger
    // if (!this.lastp) {
    //   this.lastp = Number(data.close) + 0.00000002
    // } else {
    //   this.lastp -= 0.00000002
    //   close = this.lastp.toFixed(8)
    // }
    // console.log(close)

    // add to price history
    this.prices.push({close, date})

    if (this.prices.length < MIN_DATA_POINTS) return false

    var result = this.prices.reduce(this.getReducer(this.trigger), false)
    var alert = result.triggered

    if (alert) {
      // console.log('>>>>> triggered')
      var now = new Date()
      if (this.lastTriggerDate) {
        alert = this.throttle(now)
        if (alert) this.lastTriggerDate = now
      } else {
        this.lastTriggerDate = now
      }
    }
    
    if (!this.history) {
      if (this.prices.length > MAX_DATA_POINTS) this.prices.shift()
    } else {
      this.cleanUpHistory()
    }

    return alert
  }

  cleanUpHistory() {
    var first = this.prices[0]
    var last = this.prices[this.prices.length - 1]

    while (last.date.getTime() - first.date.getTime() > this.history) {
      this.prices.shift()
      first = this.prices[0]
    }
  }
}

class AlertStoreClass {
	constructor() {
		this.emitter = new EventEmitter()

		// contains Alert objects
		this.alerts = []

    // which symbols have been subscribed
    this.subscriptions = {}

    if (localStorage.getItem('alerts')) {
      var arr = JSON.parse(localStorage.getItem('alerts'))
      arr.forEach(a => {
        var alert = new Alert(a)
        this.set(alert)
      })
    }

    RequestNotificationPermission()

    if (localStorage.getItem('rearm_interval')) {
      ALERT_FREQEUNCY = Number(localStorage.getItem('rearm_interval'))
    }
	}

	emit(evt, arg) {
    this.emitter.emit(evt, arg)
  }

  on(evt, fun) {
    this.emitter.on(evt, fun)
  }

  check(symbol, data) {
    var arr = this.alerts.filter(a => {
      return a.symbol === symbol
    })

    var shouldSave = arr.reduce((shouldSave, a) => {
      if (a.check(data)) {
        var type = this.getDescriptionForTriggerType(a.trigger)
        ShowNotification(
          `Alert for ${a.symbol} ${type} ${a.target} has been triggered!`)
        return true
      }
      return shouldSave
    }, false)

    // store last triggered time in local storage
    // in case user closes tab and reopens very soon
    if (shouldSave) this.save()
  }

  set(a) {
    this.alerts.push(a)
    this.save()

    if (!this.subscriptions[a.symbol]) {
      var handle = CoinStore.subscribe(a.symbol, (data) => {
        this.check(a.symbol, data)
      })
      this.subscriptions[a.symbol] = handle
    }
  }

  unset(alert) {
    this.alerts = this.alerts.filter(a => {
      return a.id !== alert.id
    })
    this.save()

    var arr = this.alerts.filter(a => {
      return a.symbol === alert.symbol
    })
    if (arr.length === 0) {
      var handle = this.subscriptions[alert.symbol]
      CoinStore.unsubscribe(alert.symbol, handle)
      delete this.subscriptions[alert.symbol]
    }
  }

  save() {
    var arr = this.alerts.map(a => {
      let {id, target, symbol, trigger, lastTriggerDate} = a
      return {id, target, symbol, trigger, lastTriggerDate}
    })
    localStorage.setItem('alerts', JSON.stringify(arr))
  }

  getAlerts() {
  	return this.alerts
  }

  getDescriptionForTriggerType(t) {
    var arr = TriggerTypes.find(x => {
      return x[0] === t
    })
    return arr[1]
  }

  getRearmInterval() {
    return Math.round(ALERT_FREQEUNCY / 60000)
  }

  setRearmInterval(minutes) {
    ALERT_FREQEUNCY = Number(minutes) * 60000
    localStorage.setItem('rearm_interval', ALERT_FREQEUNCY + '')
  }
}

function RequestNotificationPermission() {
  if (!("Notification" in window)) return;
  if (Notification.permission !== "denied") {
    Notification.requestPermission(function(permission) { });
  }
}

function ShowNotification(text) {
  if (!("Notification" in window)) return;
  return new Notification(text);
}

var AlertStore = new AlertStoreClass()

export { AlertStore, Alert, TriggerTypes }



// WEBPACK FOOTER //
// ./src/stores/AlertStore.js